'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_CODE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Converter2 = require('./Converter');

var _Converter3 = _interopRequireDefault(_Converter2);

var _ParseError = require('./ParseError');

var _ParseError2 = _interopRequireDefault(_ParseError);

var _dateAndTime = require('../external_modules/date-and-time');

var _dateAndTime2 = _interopRequireDefault(_dateAndTime);

var _jdateformatparser = require('../external_modules/jdateformatparser');

var _jdateformatparser2 = _interopRequireDefault(_jdateformatparser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ERROR_CODE = exports.ERROR_CODE = 'error.parse.date';

var DateConverter = function (_Converter) {
  _inherits(DateConverter, _Converter);

  /**
   * Create Date converter
   * @param  {String} [format='']   date format, documentation of supported format
   *    could be found here: https://docs.oracle.com/javase/8/docs/api/java/text/SimpleDateFormat.html
   * @param  {[type]} [locale=null] locale, @deprecated
   * @return {[type]}               DateConverter constructor
   */
  function DateConverter() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, DateConverter);

    var _this = _possibleConstructorReturn(this, (DateConverter.__proto__ || Object.getPrototypeOf(DateConverter)).call(this));

    _this.momentFormat = (0, _jdateformatparser2.default)(format);

    /* istanbul ignore next */
    if (locale) {
      if (console) {
        console.log('\nWARNING:\n\nSuch DateConverter constructor \'new DateConverter(format, locale)\' signature is used.\n\'locale\' argument is deprecated and is not used any more.\nPlease, use the following constructor signature: \'new DateConverter(format)\'.\n');
      }
    }
    return _this;
  }

  _createClass(DateConverter, [{
    key: 'valueToString',
    value: function valueToString(value) {
      if (!value) {
        return '';
      }

      return _dateAndTime2.default.format(value, this.momentFormat);
    }
  }, {
    key: 'stringToValue',
    value: function stringToValue(string) {
      if (!string) {
        return null;
      }

      if (!_dateAndTime2.default.isValid(string, this.momentFormat)) {
        throw new _ParseError2.default(ERROR_CODE, { value: string });
      }

      return _dateAndTime2.default.parse(string, this.momentFormat);
    }
  }]);

  return DateConverter;
}(_Converter3.default);

exports.default = DateConverter;


//////////////////
// WEBPACK FOOTER
// ./~/@opuscapita/i18n/lib/converters/DateConverter.js
// module id = 1617
// module chunks = 0